import { Button } from "@/components/ui/button";
import { Bell, BellOff } from "lucide-react";
import { useTagFollows } from "@/hooks/useTagFollows";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

interface TagFollowButtonProps {
  tagName: string;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  showLabel?: boolean;
}

export function TagFollowButton({
  tagName,
  variant = "outline",
  size = "sm",
  showLabel = true,
}: TagFollowButtonProps) {
  const { user } = useAuth();
  const {
    isFollowing,
    checkingFollow,
    followTag,
    unfollowTag,
    isFollowingTag,
    isUnfollowingTag,
  } = useTagFollows(tagName);

  if (!user) return null;

  const handleToggle = () => {
    if (isFollowing) {
      unfollowTag(tagName);
    } else {
      followTag(tagName);
      toast.success("You'll be notified when highly-rated books are tagged with this");
    }
  };

  const loading = checkingFollow || isFollowingTag || isUnfollowingTag;

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleToggle}
      disabled={loading}
    >
      {isFollowing ? (
        <>
          <BellOff className="h-4 w-4" />
          {showLabel && size !== "icon" && <span className="ml-2">Unfollow</span>}
        </>
      ) : (
        <>
          <Bell className="h-4 w-4" />
          {showLabel && size !== "icon" && <span className="ml-2">Follow</span>}
        </>
      )}
    </Button>
  );
}
